import { apiSlice } from "./apiSlice";
import IAuctionDetail from "../models/auction/IAuctionDetail";
import IErrorInfo from "../models/account/IErrorInfo";
import { IUpdateAuction } from "../models/auction/IAuction";
import { IAuctionWatcher } from "../models/auction/IAuctionWatcher";

const ROUTE = "/auction";

export const auctionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAuctionByUrl: builder.query<IAuctionDetail, string>({
            query: (url) => `/auction/get-auction?url=${url}`
        }),
        getAuctionWatchers: builder.query<IAuctionWatcher[], string>({
            query: (auctionId) => ({
                url: `${ROUTE}/${auctionId}/watcher`,
                method: "GET"
            })
        }),
        updateAuction: builder.mutation<IErrorInfo[], IUpdateAuction>({
            query: ({ auctionId, patch }) => ({
                url: `${ROUTE}/update/${auctionId}`,
                method: "PATCH",
                body: patch
            })
        }),
        upsertAuctionWatcher: builder.mutation<IErrorInfo[], string>({
            query: (auctionId) => ({
                url: `${ROUTE}/${auctionId}/watcher`,
                method: "POST"
            })
        })
    })
});

export const {
    useGetAuctionByUrlQuery,
    useGetAuctionWatchersQuery,
    useUpdateAuctionMutation,
    useUpsertAuctionWatcherMutation
} = auctionApiSlice;
